/**
 * @file: License.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 经营证照承包商管理
 */
import request from '@/utils/request'

/**
 * 获取营业执照信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcBusinesslicenseDetailGet(data) {
  return request({
    type: 'biz',
    url: 'pc/businesslicense/detail/get',
    method: 'post',
    data
  })
}

/**
 * 添加营业执照信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcBusinesslicenseInfoAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/businesslicense/info/add',
    method: 'post',
    data
  })
}

/**
 * 修改营业执照信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcBusinesslicenseInfoUpdate(data) {
  return request({
    type: 'biz',
    url: 'pc/businesslicense/info/update',
    method: 'post',
    data
  })
}

/**
 * 获取责任险信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcInsuranceDetailGet(data) {
  return request({
    type: 'biz',
    url: 'pc/insurance/detail/get',
    method: 'post',
    data
  })
}

/**
 * 添加责任险信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcInsuranceInfoAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/insurance/info/add',
    method: 'post',
    data
  })
}

/**
 * 删除责任险信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcInsuranceInfoDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/insurance/info/delete',
    method: 'post',
    data
  })
}

/**
 * 修改责任险信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcInsuranceInfoUpdate(data) {
  return request({
    type: 'biz',
    url: 'pc/insurance/info/update',
    method: 'post',
    data
  })
}

/**
 * 根据承包商ID获取责任险信息列表(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcInsuranceListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/insurance/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID获取责任险信息列表(ndj)(微信端)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcInsuranceListNotokenGet(data) {
  return request({
    type: 'biz',
    url: 'pc/insurance/list/notoken/get',
    method: 'post',
    data
  })
}

/**
 * 添加许可证信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLicenseInfoAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/license/info/add',
    method: 'post',
    data
  })
}

/**
 * 获取许可证信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLicenseInfoGet(data) {
  return request({
    type: 'biz',
    url: 'pc/license/info/get',
    method: 'post',
    data
  })
}

/**
 * 获取许可证信息(ndj)(微信端)(根据管理方ID，获取运营商资证)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLicenseInfoNotokenGet(data) {
  return request({
    type: 'biz',
    url: 'pc/license/info/notoken/get',
    method: 'post',
    data
  })
}

/**
 * 修改许可证信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLicenseInfoUpdate(data) {
  return request({
    type: 'biz',
    url: 'pc/license/info/update',
    method: 'post',
    data
  })
}

/**
 * 获取承包商公示列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLicenseListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/license/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/License.js